import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        name: 'course-gradebook-preview',
        path: '/courses/:courseId/gradebook-preview',
        component: () => import('@/pages/gradebook-preview/GradebookPreview.vue'),
        props: route => ({
            courseId: Number.parseInt(route.params.courseId, 10),
        }),
        meta: {
            title: 'Gradebook',
            middleware: [GateKeeperMiddleware],
            ability: { action: 'view', subject: 'gradebook preview' },
        },
    },
];
